export const validationMsgs = {
  required: 'This field is mandatory.'
};
